<template>
  <main>
    <section class="wrapper align-items-center f-column min-win-height">
      <h2 class="font-center pr-2 pl-2">Inštrukcie a prehľad požadovaných fotografií</h2>

      <div class="container-860 mb-children-2">
        <div class="container-white f-center mb-6">
          <div class="container-408 pb-6 pt-3">
            <h3 class="mb-1">Inštrukcie k fotografiám vozidla</h3>

            <ul class="font-gray ml-2 mb-children-1">
              <li>Vozidlo musí byť čisté, bez nánosov špiny, námrazy, snehu, a pod.</li>
              <li>Foťte za dobrého počasia pri dennom svetle, nie však proti slnku.</li>
              <li>Fotografie musia byť ostré, bez výrazných odleskov.</li>
              <li>Foťte na šírku.</li>
              <li>Dbajte, aby bolo celé vozidlo, vrátane kolies a strešného okna, viditeľné a vypĺňalo čo najväčšiu plochu fotografie.</li>
              <li>Foťte iba VIN číslo vyrazené do karosérie alebo rámu vozidla. Ak je nečitateľné, odfoťte aj ďalšie identifikačné štítky a nálepky s VIN číslom.</li>
              <li>Akceptované budú len fotografie s minimálnym rozlíšením {{ MIN_IMAGE_WIDTH }} x {{ MIN_IMAGE_HEIGHT }} px.</li>
              <li>Po úspešnom odoslaní fotografií Vám na Vami zadanú emailovú adresu pošleme potvrdenie o ich prijatí v našom systéme.</li>
            </ul>
          </div>
        </div>

        <div class="container-white f-center">
          <div class="container-full pb-6 pt-3">
            <h3 class="mb-1">Prehľad požadovaných fotografií</h3>

            <p class="mb-3">
              V ďalšom kroku bude potrebné nahrať nasledovné fotografie vozidla:
            </p>

            <ul class="font-gray" v-if="inspectionResponse">
              <summary-file-item  v-for="(item,index) in inspectionResponse.inspectionPhotos"
                                  :key="index"
                                  :files-count="item.maximumPictures"
                                  :type="item.type">
                {{photoDesc[item.type.toUpperCase()]  }}</summary-file-item>
            </ul>
          </div>
        </div>
      </div>

      <!-- CTA buttons -->
      <div class="cta-buttons width-10 f-center mb-8 priority-6">
        <div class="width-10 width-9-768 f-center mr-children-2 justify-content-end-768 align-items-center-768">
          <button @click="$router.goToStep(1)" class="button-white button-border-gray previous">
            <i class="mr-1 icon icon--arrow-left"></i>
            <div>Späť</div>
          </button>

          <button
            class="button-red continue"
            @click="$router.goToStep(3)"
            v-scroll-to-error
          >
            <div>Pokračovať</div>
            <i class="desktop-arrow ml-2 icon icon--arrow-right"></i>
            <i class="mobile-arrow icon icon--arrow-right-mobile" style="vertical-align: middle;"></i>
          </button>
        </div>
      </div>

      <!-- Footer -->
      <transparent-footer></transparent-footer>
    </section>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { photoDesc } from '@/enums';
import { MIN_IMAGE_WIDTH, MIN_IMAGE_HEIGHT } from '@/config';
import SummaryFileItem from '../components/SummaryFileItem.vue';

export default {
  name: 'Step2',
  components: { SummaryFileItem },
  data() { return { photoDesc, MIN_IMAGE_WIDTH, MIN_IMAGE_HEIGHT }; },
  computed: {
    ...mapGetters({
      inspectionResponse: 'getInspectionResponse',
      model: 'getModel',
    }),
  },
  beforeCreate() {
    this.$store.commit('SET_STEP', 2);
    this.$store.commit('SET_LASTSTEP', 2);
  },
};
</script>
